import {
  FETCH_DAILY_RECORDS,
  FETCH_DAILY_RECORDS_SUCCESS,
  FETCH_DAILY_RECORDS_FAILURE,
} from "./constants";

const initialState = {
  isFetching: false,
  // The day (YYYY-MM-DD) and location the rows in `residents` belong to.
  date: null,
  locationId: null,
  // Per-resident groups: { resident: {uuid,name}, observations: [row…] }.
  residents: null,
  // { residents, observations, red, amber } — server-side counts for the day.
  summary: null,
  fetchedAt: null,
  error: null,
};

const DailyRecordsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DAILY_RECORDS:
      // Keep the rows (and their `date` / `locationId`) while the next day
      // loads: the page shows them dimmed under a progress bar, and checks
      // `date` / `locationId` itself before treating them as the day asked for.
      return { ...state, isFetching: true, error: null };
    case FETCH_DAILY_RECORDS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        date: action.payload?.date ?? state.date,
        locationId: action.payload?.locationId ?? null,
        residents: action.payload?.residents ?? [],
        summary: action.payload?.summary ?? null,
        fetchedAt: action.payload?.fetchedAt ?? null,
      };
    case FETCH_DAILY_RECORDS_FAILURE:
      return { ...state, isFetching: false, error: true };
    default:
      return state;
  }
};

export default DailyRecordsReducer;
